import { Router, ActivatedRoute } from '@angular/router';
import { AfterViewInit, Component, Inject, OnChanges, OnInit } from '@angular/core';
import { AuthService } from '../authentication/auth.service';
import { OrdersService } from '../services/orders/orders.service';
import { Query, User } from 'src/app/shared/models/types';
import { Apollo} from 'apollo-angular';
import { ErrorHandlerService } from 'src/app/core/http/error-handler.service';
import { Observable, Subscription } from 'rxjs';
import { UsersMainInfo } from 'src/app/shared/models/graphql';
import { catchError, map } from 'rxjs/operators';
import { UserService } from '../authentication/user.service';
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT } from '@angular/common';




@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css', './header.component.rtl.css']
})
export class HeaderComponent implements OnInit, AfterViewInit {
  // ______properties_______
  public oneUser:User;
  private usersSubscription: Subscription;
  public isVerified: boolean;
  // _______ boolean
  public isSidebarOpen:boolean = false;
  public isUser:boolean = false;
  public languageSite :string = 'العربية'
  public languageMobi :string = 'ع'
  public language = 'ar';
  public dir = 'ltr';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _AuthService: AuthService,
    public _OrdersService: OrdersService,
    private apollo: Apollo,
    private errorHandlerService: ErrorHandlerService,
    private _UserService: UserService,
    public _TranslateService: TranslateService,
    @Inject(DOCUMENT) private document: Document,

    ) {
    }




  ngOnInit(): void {}

  ngAfterViewInit() {

       // chck if usr is exist
       this._AuthService.firebaseUser.subscribe( user => {
        if ( user ) {
          this.isUser = true;
                // this.usersSubscription
        // get user data from backend
        this.usersSubscription = this.apollo.watchQuery<Query>({
          query: UsersMainInfo,
          // fetchPolicy: "no-cache"
        }).valueChanges.pipe(
          map(result => result.data.users[0]),
          catchError( error =>  this.errorHandlerService.handleError(error))
        ).subscribe( user => {
          this.oneUser = user
        })
        } 
        else {
          this.isUser = false;
        }
      })

 
  }



  // When user click change language
  changeLanguage() {
    if(this.language === 'ar'){
      this._TranslateService.use('ar')
      this.language = 'en';
      this.document.dir = 'rtl';
      this.dir = 'rtl';
    } else {
      this._TranslateService.use('en')
      this.language = 'ar';
      this.document.dir = 'ltr';
      this.dir = 'ltr';
    }
    this.languageSite = this._TranslateService.currentLang === 'en' ? 'العربية' : 'English';
    this.languageMobi = this._TranslateService.currentLang === 'en' ? 'ع' : 'En';
  }

  // open and close sidebar
  toggleSidebar() {
    this.isSidebarOpen = ! this.isSidebarOpen
  }

  
  ngOnDestroy() {
  }


}
